import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchDetailsStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainPaper: {
            marginTop: "-3px",
        },
        text: {
            fontWeight: 500,
            marginBottom: "5px",
            fontSize: "18px",
        },
        highlightedText: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "20px",
        },
        selected: {
            cursor: "auto",
            backgroundColor: "#F8F8F8",
        },
        title: {
            marginTop: "40px",
        },
        collapse: {
            marginRight: "30px",
        },
        loadingContainer: {
            height: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        divider: {
            margin: "60px 50px 30px 30px",
        },
    })
);
